import {
  AdminPanelSettingsRounded,
  ChatBubbleRounded,
  CommentRounded,
  CommentsDisabledRounded,
  RemoveRedEyeRounded,
  VisibilityOffRounded,
} from "@mui/icons-material";
import { Badge, Box, ButtonBase } from "@mui/material";
import { DateTime } from "luxon";
import { useNavigate } from "react-router-dom";

import useAuth from "../../../../config/context/authContext";
import { GreyPallet } from "../../../../config/styles";
import { UtilComponents } from "../../../../config/util/utilComponents";

import MainText from "../../../../components/MainText";

import { ChatItem } from "../../../../types/database";

export default function ChatItemComponent({ chat }: { chat: ChatItem }) {
  const navigate = useNavigate();

  const { currentUserState } = useAuth();

  const othersInTheChat = chat.usersDetails.filter((item) => item.userId !== currentUserState?.uid);

  const readAllMessages =
    chat.lastMessage?.userId === currentUserState?.uid ||
    chat.lastMessage?.id ===
      (chat?.usersLastRead ? chat?.usersLastRead[String(currentUserState?.uid)] : null);

  return (
    <Badge
      sx={{ width: "100%" }}
      color="error"
      variant="dot"
      componentsProps={{
        badge: {
          style: {
            transform: "translate(-10px, 10px)",
            transition: "200ms",
            opacity: readAllMessages ? 0 : 1,
          },
        },
      }}
    >
      <ButtonBase
        sx={{
          mb: 2,
          width: "100%",
          borderRadius: "15px",
          overflow: "hidden",
          boxSizing: "border-box",
          "& div": { boxSizing: "border-box !important" },
        }}
        onClick={() => navigate("/account/chat/" + chat.id, { state: chat })}
      >
        <Box
          p={2}
          style={{
            width: "100%",
            backgroundColor: GreyPallet.Light,
            borderRadius: "15px",
          }}
        >
          {chat.postId ? (
            <Box
              mb={2}
              p={2}
              sx={{
                width: "100%",
                backgroundColor: GreyPallet.LightGhost,
                borderRadius: "15px",
                textAlign: "left",
              }}
            >
              <MainText size="small" color="regular">
                Criado a partir do post:
              </MainText>
              <MainText size="caption" color="black" inline canOverflow>
                {chat.postDetails?.content}
              </MainText>
            </Box>
          ) : null}

          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            sx={{ flex: 1 }}
            width={"100%"}
          >
            <Box
              width={"100%"}
              flex={1}
              display={"flex"}
              flexDirection={"column"}
              alignItems={"start"}
              overflow={"hidden"}
            >
              <Box
                flex={1}
                display={"flex"}
                justifyContent={"start"}
                alignItems={"center"}
                flexWrap={"wrap"}
                flexDirection={"column"}
                width={"100%"}
              >
                {chat.isStaff && !UtilComponents.isStaff(currentUserState) ? (
                  <Box width={"100%"}>
                    <MainText size="body" color="black" left canOverflow>
                      Desenvolvedor
                    </MainText>
                  </Box>
                ) : (
                  <>
                    {othersInTheChat.map((item, index) => (
                      <Box marginRight={"4px"} flex={1} key={item.userId} width={"100%"}>
                        <MainText size="body" color="black" left canOverflow>
                          {item.name || "-"}
                          {`${index !== othersInTheChat.length - 1 ? "," : ""}`}
                        </MainText>
                      </Box>
                    ))}

                    {UtilComponents.isStaff(currentUserState) &&
                      othersInTheChat.map((item, index) => (
                        <Box marginRight={"4px"} flex={1} key={item.userId} width={"100%"}>
                          <MainText size="small" left color="regular">
                            {item.email}
                            {`${index !== othersInTheChat.length - 1 ? "," : ""}`}
                          </MainText>
                        </Box>
                      ))}
                  </>
                )}
              </Box>

              <MainText size="tiny" color="regular">
                {DateTime.fromMillis(chat.updatedAtTimestamp).toFormat("dd/LL/y HH:mm")}
              </MainText>
            </Box>

            {chat.isStaff ? (
              <Box display={"flex"} gap={1} justifyContent={"center"} alignItems={"center"}>
                {UtilComponents.isStaff(currentUserState) && (
                  <Box sx={{ color: GreyPallet.Regular, fontSize: 14 }} display={"flex"} gap={1}>
                    {chat.enabled ? (
                      <CommentRounded fontSize="inherit" />
                    ) : (
                      <CommentsDisabledRounded fontSize="inherit" />
                    )}
                    {chat.visible ? (
                      <RemoveRedEyeRounded fontSize="inherit" />
                    ) : (
                      <VisibilityOffRounded fontSize="inherit" />
                    )}
                  </Box>
                )}

                <AdminPanelSettingsRounded />
              </Box>
            ) : (
              <ChatBubbleRounded />
            )}
          </Box>
        </Box>
      </ButtonBase>
    </Badge>
  );
}
